import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { RequisitionsConfigSelectors } from '@recruitee/requisitions-settings-data';

export const isRequisitionRequired$ = (store: Store) =>
  store
    .select(RequisitionsConfigSelectors.data)
    .pipe(map(config => (config?.enabled ? !!config?.requisitionsRequiredForOffers : false)));
